/* eslint-disable no-console */
import compareVersions from 'compare-versions';
import Bundle from './bundle';
import { CORE_VERSION } from './constants';
import * as Version from '../version.json';

/**
 * @description Carrega a versão no Bundle para validação do Core utilizado no front-end
 *
 * @param version
 */
export const accumulateVersions = (version: string): void => {
  Bundle.accumulate(CORE_VERSION, version);
};
/**
 * @description Valida as versões do Core Engine utilizadas nos submodulos,
 * para garantir que o Front-end consumidor instancie a versão maior correspondente do Core Engine.
 */
export const validateVersion = (): {
  result: number;
  versionData: {
    version: string;
    versionDefs: string;
  } | null;
} => {
  const version = Version.root;

  const versions = Bundle.getValue(CORE_VERSION);
  if (versions && Array.isArray(versions) && versions.length > 0) {
    const sortVersions = [...versions].sort(compareVersions);
    const sortDescending = [...sortVersions].reverse();
    const result = compareVersions(version, sortDescending[0]);
    return {
      result,
      versionData: { version, versionDefs: sortDescending[0] },
    };
  }
  return {
    result: 0,
    versionData: null,
  };
};
